<template>
  <div>
    <img src="@/assets/tarjeta_ofertas_seguro_salud.jpg" style="width: 100%" />
    <p class="tituloTarjeta">SEGUROS DE SALUD</p>
    <p>
      Cuida de ti hoy y siempre con MMT Seguros.
    </p>
    <ul style="list-style-type: disc">
      <li>Asistencia sanitaria</li>
      <li>Cobertura dental</li>
      <li>Asistencia en viajes</li>
      <li>Videoconsulta médica</li>
    </ul>
    <p>
      <b>Tranquilidad para ti y los tuyos. Tu Seguro de Salud desde 39€ al mes.</b>
    </p>
    <p class="container-flex">
      <a :href="'tel:' + telefonoOwner">
        <button class="pure-button botonLlamar" title="Pulsa el botón para llamar a tu oficina MMT">
          Llama e infórmate
        </button>
      </a>

    </p>

  </div>
</template>

<script>
/* eslint-disable no-console */
export default {
  data() {
    return {
      telefonoOwner:
        this.$store.state.portfolio.cliente.telefonoOwnerPropioCliente,
    };
  },


};
</script>

<style lang="scss" scoped>
.container-flex {
  margin-top: 2.5rem;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}

.botonLlamar {
  background-color: $colorMMT;
  color: white;
  font-weight: bold;
  width: 13rem;
  border: 0.15rem solid;
  border-radius: 0.5rem;
  text-align: center;
}

// .container-flex a:first-child {
//   margin-right: 15%;
// }
</style>
